import React from 'react';
import PropTypes from 'prop-types';

export default function Item({ title, value }) {
  return (
    <div className="d-flex  justify-content-between mt-2">
      <div className="icon-with-text">
        <i className="rounded-circle small-icon bg-gray-900 text-white text-center" />

        <div className="text-content">
          {title}
        </div>

      </div>

      <div className="value">{value}</div>
    </div>
  );
}

Item.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
